import _ from "lodash";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { fiveWhyStatus, FiveWhyType, isStrapi } from "src/api/config/systemSwitch";
import Loading from "src/components/Loading";
// import ActionsMainPageTable from "src/components/tables/actionsMainPageTable";
import List5WayMainPageTable from "src/components/tables/list5WayMainPageTable.mobile";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";

type List5WayMainPageProps = {
    type: string;
    user: string;
    id: string;
    openComponentId: string;
    setOpenComponentId: React.Dispatch<React.SetStateAction<string>>;
    email?: string;
}

const List5WayMainPage = ({ type, user, id, openComponentId, setOpenComponentId, email }: List5WayMainPageProps) => {

    // const [open, setOpen] = useState(false);
    const [items5way, setItems5Way] = useState<any>([]);
    const currentUser: any = useAppSelector(selectCurrentUser);
    const [customLoading, setCustomLoading] = useState(true);
    const location = useLocation();
    const dispatch = useAppDispatch();

    const isOpen = openComponentId === id;

    useEffect(() => {
        if (currentUser.email) {
            setCustomLoading(true);
            getItemsRequest({
                listName: myTasks5WayListName,
                filters: { [user]: email && `${email}*` || `${currentUser.email}*`,
                Status: [fiveWhyStatus.process, fiveWhyStatus.old],
                Type5Way: type } }).then((results: any) => {
                let list5WayIds: string[] = [];
                let emails: any = [];
                let list5Way = [...results.items];
                list5Way.map((item: any) => {
                    item.Editors && item.Editors.split(";").map((email: string) => {
                        emails = [...emails, email];
                    });
                    list5WayIds = [...list5WayIds, item.ID];
                });
                if (emails.length > 0) {
                    dispatch(addUsers([..._.uniqWith(emails, _.isEqual)]));
                }
                if (list5WayIds.length > 0) {
                    getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: list5WayIds } }).then(results => {
                        const sdcaItems = [...results.items];
                        let arrRequests: any = [];
                        sdcaItems.map(item => {
                            arrRequests = [...arrRequests, getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: type === FiveWhyType && `#5Почему_${item.ID}` || `#Отчет_об_отклонениях_${item.ID}` } })];
                        });
                        Promise.all(arrRequests).then(values => {
                            let actions: any = [];
                            values.map(value => {
                                actions = [...actions, ...value.items];
                            });
                            const returnItems = list5Way.map((item: any) => {
                                const currentSdcaItems = sdcaItems.filter((sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === item.ID);
                                let currentActions: any = [];
                                currentSdcaItems.map((currentSdcaItem: any) => {
                                    currentActions = [...currentActions, ...actions.filter(
                                        (action: any) => {
                                            if (type === FiveWhyType) {
                                                return action.ImportantHashTag.indexOf(`5Почему_${currentSdcaItem.ID}`) !== -1
                                            } else {
                                                return action.ImportantHashTag.indexOf(`Отчет_об_отклонениях_${currentSdcaItem.ID}`) !== -1
                                            }
                                        }
                                    )]
                                });
                                return {
                                    ...item,
                                    rootTree: item.Tree && item.Tree.indexOf(`"root":true`) !== -1 && 'Да' || 'Нет',
                                    actions: currentActions,
                                    actionsPlan: currentActions.length > 0 && 'Да' || 'Нет',
                                };
                            });
                            if (user === 'AuthorEmail') {
                                setItems5Way([...returnItems]);
                            }
                            if (user === 'Editors') {
                                setItems5Way([...returnItems.filter(item => item.Editors && item.Editors.split(';')[0] !== currentUser.email)]);
                            }
                            setCustomLoading(false);
                        });
                    });
                } else {
                    setCustomLoading(false);
                }
            });
        }
    }, [currentUser, location]);

    return (
        <section className="mb-7.5 cursor-pointer w-full flex-col flex">
            <FlexRow onClick={() => setOpenComponentId(isOpen ? "" : id)} className="w-full flex justify-between items-center mb-5">
                <h3 className="text-[#637381] flex items-center font-medium text-[14px]">
                    {(type === FiveWhyType || type === '5Way')  && user === 'AuthorEmail' && 
                        <>
                            5Почему (автор) · {customLoading && <>&nbsp;<Loading /></> || items5way.length}
                        </> || (type === FiveWhyType || type === '5Way') && user === 'Editors' &&

                        <>
                            5Почему (участник) · {customLoading && <>&nbsp;<Loading /></> || items5way.length}
                        </> || type === 'DeviationReport' && user === 'AuthorEmail' &&
                        <>
                            Отчеты об отклонениях (автор) · {customLoading && <>&nbsp;<Loading /></> || items5way.length}
                        </> || type === 'DeviationReport' && user === 'Editors' &&
                        <>
                            Отчеты об отклонениях (участник)&nbsp;·&nbsp;{customLoading && <>&nbsp;<Loading /></> || items5way.length}
                        </>  || type + ' - ' + FiveWhyType
                    }
                </h3>
                {!isOpen &&
                    <ArrowDown />
                    ||
                    <ArrowUp />
                }
            </FlexRow>
            {isOpen &&
                <FlexCol className="w-full gap-5">

                    {customLoading && <div className="mt-5 mb-5 flex items-center justify-center w-full"><Loading /></div> ||
                        <>
                            <List5WayMainPageTable data={items5way} type={type} />
                        </>
                    }
                </FlexCol>
            }
        </section>
    );
};

export default List5WayMainPage;
